import {RossPocComponent} from "./RossPocComponent";


export function RossPocScreen() {
  return (<>
    <RossPocComponent/>
  </>)
}
